var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:" z-1000",class:_vm.noSticky ? '' : 'sticky-top'},[_c('NavHeader',{attrs:{"modalSearchHeaderId":_vm.modalSearchHeaderId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }